import { useEffect } from "react";
import Services from '../table/Tableservices';
import Button from '@mui/material/Button';
import DeleteIcon from '@mui/icons-material/Delete';
import SendIcon from '@mui/icons-material/Send';
import Stack from '@mui/material/Stack';
import Modal from "../modal/Modaladdservice"


const Dashboard = () => {
  useEffect(() => {
    // getPromise(["sales", "purchases"]);
  }, []);


  return (
    <>
    <Modal/>
    <Services/>
    
     
     </>
  );
};

export default Dashboard;
